//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import dayjs from 'dayjs';
//#endregion

/**
 * 보호구 관리 - 보호구 지급대장 (PPE_BASIC_03) 전용 로직
 * other 케이스에서 사용
 */

// 보호구 지급대장 인쇄 함수
export const PrintLogic1 = async (
  documentData, // documentData는 사용하지 않지만 시그니처 통일을 위해 유지
  dispatch,
  setLoading,
  rowData1,
  searchRef
) => {
  if (!rowData1 || rowData1.length === 0) {
    dispatch(
      showSnackbar({
        message: '인쇄할 데이터가 없습니다.',
        type: 'warning',
      })
    );
    return null;
  }

  setLoading(true);
  try {
    // 검색 연도 추출 (currentYear 사용)
    const currentYear = searchRef?.current?.currentYear;
    let year = '';

    if (currentYear) {
      year = currentYear.toString();
    } else {
      // 날짜가 없으면 현재 연도 사용
      year = dayjs().year().toString();
    }

    // HeaderData에 선택한 연도 추가
    const headerData = {
      YEAR: year,
    };

    // 천단위 구분 기호 추가 함수
    const formatNumber = (value) => {
      if (value == null || value === '') return '0';
      const num = typeof value === 'number' ? value : Number(value);
      return isNaN(num) ? '0' : num.toLocaleString('ko-KR');
    };

    // 이미지를 Base64로 변환하는 함수
    const getBase64ImageSafe = async (imagePath) => {
      if (!imagePath) return '';

      try {
        const imageUrl = `${Global.file.useUrl}files/${imagePath}`;
        const response = await fetch(imageUrl);

        if (!response.ok) return '';

        const blob = await response.blob();

        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => resolve('');
          reader.readAsDataURL(blob);
        });
      } catch (error) {
        console.error('이미지 변환 실패:', imagePath, error);
        return '';
      }
    };

    // TableData에 그리드 데이터 매핑 (레포트 양식에 맞게)
    const tableData = await Promise.all(
      rowData1.map(async (row, index) => {
        // 서명 이미지 처리 (issuSign이 'Y'이고 서명 경로가 있는 경우)
        let signImageBase64 = '';
        if (row.issuSign === 'Y' && row.issuSignPath) {
          const base64Image = await getBase64ImageSafe(row.issuSignPath);
          if (base64Image) {
            signImageBase64 = base64Image.replace(
              /^data:image\/[a-z]+;base64,/,
              ''
            );
          }
        }

        // 날짜 형식 변환 (camelCase 필드명 사용)
        const createDate = row.createDate
          ? dayjs(row.createDate).format('YYYY-MM-DD')
          : '';

        return {
          no: index + 1,
          USER_NM: row.userNm || '',
          EQUIP_NM: row.equipNm || '',
          REASON: row.reason || '',
          CREATE_DATE: createDate,
          QTY: formatNumber(row.qty),
          ISSU_SIGN: signImageBase64, // Base64 이미지 문자열
          STOCK_QTY: formatNumber(row.stockQty),
          MANAGE_R_DEP_NM_LAST: row.managerDepNmLast || '',
          MANAGE_R_NM: row.managerNm || '',
          REMARK: row.remark || '',
        };
      })
    );

    const printData = {
      FileName: 'PPE_BASIC_01',
      HeaderData: JSON.stringify(headerData),
      TableData: JSON.stringify(tableData),
    };

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    // response.data가 blob인 경우 그대로 반환
    if (response.data instanceof Blob) {
      return response.data;
    }
    // response.data가 다른 형태인 경우 blob으로 변환
    else if (response.data) {
      return new Blob([response.data], { type: 'application/pdf' });
    } else {
      console.error('PrintLogic1: 응답 데이터가 없습니다.');
      return null;
    }
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 데이터 생성에 실패했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
